import type React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { type AutocompleteProps } from '@mui/material/Autocomplete';
import clsx from 'clsx';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

import './ComboBox.scss';

type TPHComboBoxProps<T> = Omit<AutocompleteProps<T, false, boolean, false>, 'renderInput'> & {
    label?: React.ReactNode;
    helperText?: React.ReactNode;
    fullWidth?: boolean;
    error?: boolean;
    required?: boolean;
    name?: string;
    style?: React.CSSProperties;
};

export function ComboBox<T>(props: TPHComboBoxProps<T>) {
    const { label, className, disabled, error, style, helperText, fullWidth, required, name, ...autocompleteProps } = props;

    return (
        <Autocomplete
            className={clsx('ms_combobox', className)}
            disabled={disabled}
            fullWidth={fullWidth}
            style={style}
            popupIcon={<KeyboardArrowDownRoundedIcon />}
            componentsProps={{ popper: { className: 'ms_combobox_popup' } }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    name={name}
                    label={label}
                    variant="filled"
                    error={error}
                    helperText={helperText}
                    required={required}
                />
            )}
            {...autocompleteProps}
        />
    );
}
